var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ComposedMenuItemCollapsible',{attrs:{"link-tag":"button","to":"#","title":_vm.$t('language'),"prefixIcon":{
        name: 'languages',
        path: 'activatable',
        activatable: true,
    }},on:{"input":function($event){return _vm.$emit('open')}},scopedSlots:_vm._u([{key:"suffix",fn:function(){return [_c('span',{staticClass:"suffix-content d-flex align-items-center"},[_c('span',{staticClass:"locale"},[_vm._v("\n                "+_vm._s(_setup.currentLocale.toUpperCase())+"\n            ")]),_vm._v(" "),_c('BaseImageSvgThemedIcon',{attrs:{"name":"right","path":"arrows","size":"l","activatable":""}})],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }